import { Typography, styled } from '@mui/material';
import { up } from '../../../../theme';

export const classes = {
  root: 'root',
  membersAgGridStyle: 'membersAgGridStyle',
  membersAgGridStyleForMember: 'membersAgGridStyleForMember',
  addMoreButtonBox: 'addMoreButtonBox',
  activeChipColor: 'activeChipColor',
  inActiveChipColor: 'inActiveChipColor',
  notRegistered: 'noRegistered',
  deleteUserIcon: 'deleteUserIcon',
  cardComponent: 'cardComponent',
  errorCardComponent: 'errorCardComponent',
  cardHeader: 'cardHeader',
  closeAction: 'closeAction',
  cardContent: 'cardContent',
  subTitle: 'subTitle',
  emailTextFieldText: 'emailTextFieldText',
  textField: 'textField',
  addUserBtn: 'addUserBtn',
  formHelperText: 'formHelperText',
  loaderBox: 'loaderBox',
  Table_Chart_Button_Box: 'Table_Chart_Button_Box',
  Table_Chart_Button_Inner_wrapped_Box: 'Table_Chart_Button_Inner_wrapped_Box',
  Table_Chart_Button: 'Table_Chart_Button',
  ADD_User_Button: 'ADD_User_Button',
  moreHeight: 'moreHeight',
  avatar: 'avatar',
  deleteIcon: 'deleteIcon',
  newFlowBackdrop: 'newFlowBackdrop',
  DeleteMemberCardHeader: 'DeleteMemberCardHeader',
  DeleteMemberCardContent: 'DeleteMemberCardContent',
  actionButtonBox: 'actionButtonBox',
  cancelButton: 'cancelButton',
  saveButton: 'saveButton',
  memberCards: 'memberCards',
};
export const EmailLabelTypo = styled(Typography)(({ theme }) => ({
  fontWeight: 500,
  paddingBottom: theme.spacing(0.5),
}));

export const RoleLabelTypo = styled(Typography)(({ theme }) => ({
  fontWeight: 500,
  paddingBottom: theme.spacing(0.5),
  paddingTop: theme.spacing(1.5),
}));
export const ExpireTimeLabelTypo = styled(Typography)(({ theme }) => ({
  fontWeight: 500,
  paddingBottom: theme.spacing(0.5),
  marginTop: theme.spacing(1.5),
}));

export const Root = styled('div')(({ theme }) => ({
  [`&.${classes.root}`]: {
    height: '100%',
    overflow: 'auto',
    '&::-webkit-scrollbar': {
      width: 0,
    },
  },
  [`& .${classes.membersAgGridStyle}`]: {
    [up('xs')]: {
      height: '46vh',
    },
    [up('sm')]: {
      height: '54vh',
    },
    [up('md')]: {
      height: '54vh',
    },
    [up('lg')]: {
      height: '57vh',
    },
    [up('xl')]: {
      height: '70vh',
    },
    [up('xxl')]: {
      height: '72vh',
    },
  },
  [`& .${classes.avatar}`]: {
    backgroundColor: theme.palette.primary.main,
    [up('xs')]: {
      height: '30px',
      width: '30px',
    },
    [up('md')]: {
      height: '40px',
      width: '40px',
    },
    [up('lg')]: {
      height: '70px',
      width: '70px',
    },
  },
  [`& .${classes.moreHeight}`]: {
    [up('xs')]: {
      height: '46vh',
    },
    [up('sm')]: {
      height: '62vh',
    },
    [up('md')]: {
      height: '64vh',
    },
    [up('lg')]: {
      height: '65vh',
    },
    [up('xl')]: {
      height: '75vh',
    },
    [up('xxl')]: {
      height: '76vh',
    },
  },
  [`& .${classes.membersAgGridStyleForMember}`]: {
    [up('xs')]: {
      height: '46vh',
    },
    [up('sm')]: {
      height: '60vh',
    },
    [up('md')]: {
      height: '61vh',
    },
    [up('lg')]: {
      height: '65vh',
    },
    [up('xl')]: {
      height: '75vh',
    },
    [up('xxl')]: {
      height: '76vh',
    },
  },
  [`& .${classes.Table_Chart_Button_Inner_wrapped_Box}`]: {
    border: `1px solid ${theme.palette.darkPurple.lightest}`,
    borderRadius: '5px',
  },
  [`& .${classes.Table_Chart_Button}`]: {
    margin: theme.spacing(0.5),
    [up('xs')]: {
      width: '70px',
      height: '23px',
    },
    [up('sm')]: {
      width: '87px',
      height: '27px',
    },
    [up('md')]: {
      width: '83px',
      height: '25px',
    },
    [up('lg')]: {
      width: '90px',
      height: '30px',
    },
    [up('xl')]: {
      width: '95px',
      height: '33px',
    },
    [up('xxl')]: {
      width: '103px',
      height: '35px',
    },
  },
  [`& .${classes.ADD_User_Button}`]: {
    margin: theme.spacing(0.5),
    padding: '0px 4px',
    [up('xs')]: {
      height: '23px',
    },
    [up('sm')]: {
      height: '27px',
    },
    [up('md')]: {
      height: '25px',
    },
    [up('lg')]: {
      height: '30px',
    },
    [up('xl')]: {
      height: '33px',
    },
    [up('xxl')]: {
      height: '35px',
    },
  },
  [`& .${classes.Table_Chart_Button_Box}`]: {
    display: 'flex',
    gap: '16px',
    justifyContent: 'flex-end',
    marginTop: '8px',
    marginBottom: '8px',
  },
  [`& .${classes.addMoreButtonBox}`]: {
    width: '100%',
    display: 'flex',
    justifyContent: 'flex-end',
  },
  [`& .${classes.activeChipColor}`]: {
    background: theme.palette.colorGreen.main,
  },
  [`& .${classes.inActiveChipColor}`]: {
    background: theme.palette.colorRed.main,
  },
  [`& .${classes.notRegistered}`]: {
    background: theme.palette.venetianRed.main,
  },
  [`& .${classes.deleteUserIcon}`]: {
    fill: 'none',
    stroke: theme.palette.colorRed.main,
    cursor: 'pointer',
  },
  [`& .${classes.cardComponent}`]: {
    borderRadius: '5px',
    [up('xs')]: {
      width: '295px',
    },
    [up('sm')]: {
      width: '410px',
    },
    [up('md')]: {
      width: '425px',
    },
    [up('lg')]: {
      width: '500px',
    },
    [up('xl')]: {
      width: '530px',
    },
    [up('xxl')]: {
      width: '650px',
    },
  },
  [`& .${classes.errorCardComponent}`]: {
    borderRadius: '5px',
    [up('xs')]: {
      width: '295px',
      height: '420px',
    },
    [up('sm')]: {
      width: '410px',
      height: '410px',
    },
    [up('md')]: {
      width: '425px',
      height: '430px',
    },
    [up('lg')]: {
      width: '500px',
      height: '460px',
    },
    [up('xl')]: {
      width: '530px',
      height: '510px',
    },
    [up('xxl')]: {
      width: '650px',
      height: '590px',
    },
  },
  [`& .${classes.cardHeader}`]: {
    background: theme.palette.japanBlush.main,
    borderBottom: `1px solid ${theme.palette.lunarBase.lightest}`,
  },
  [`& .${classes.deleteIcon}`]: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '35px',
    height: '35px',
    borderRadius: '8px',
    backgroundColor: 'rgba(255, 0, 0, 0.1)',
  },
  [`& .${classes.closeAction}`]: {
    cursor: 'pointer',
    [up('xs')]: {
      width: '10px',
      height: '10px',
    },
    [up('sm')]: {
      width: '12px',
      height: '12px',
    },
    [up('md')]: {
      width: '14px',
      height: '14px',
    },
    [up('lg')]: {
      width: '16px',
      height: '16px',
    },
    [up('xl')]: {
      width: '18px',
      height: '18px',
    },
    [up('xxl')]: {
      width: '20px',
      height: '20px',
    },
  },
  [`& .${classes.cardContent}`]: {
    [up('xs')]: {
      margin: '4px 0px 0px',
    },
    [up('sm')]: {
      margin: '4px 2px 0px',
    },
    [up('md')]: {
      margin: '5px 2px 0px',
    },
    [up('lg')]: {
      margin: '10px 5px 0px',
    },
    [up('xl')]: {
      margin: '13px 8px 0px',
    },
    [up('xxl')]: {
      margin: '18px 11px 0px',
    },
  },
  [`& .${classes.subTitle}`]: {
    color: theme.palette.shoeWax.dark,
    [up('xs')]: {
      marginBottom: theme.spacing(1),
    },
    [up('sm')]: {
      marginBottom: theme.spacing(1.3),
    },
    [up('md')]: {
      marginBottom: theme.spacing(1.5),
    },
    [up('lg')]: {
      marginBottom: theme.spacing(1.5),
    },
    [up('xl')]: {
      marginBottom: theme.spacing(2),
    },
    [up('xxl')]: {
      marginBottom: theme.spacing(2.5),
    },
  },
  [`& .${classes.emailTextFieldText}`]: {
    fontWeight: 500,
    paddingBottom: theme.spacing(1.5),
  },
  [`& .${classes.textField}`]: {
    '& .MuiInputBase-input': {
      [up('xs')]: {
        height: '6px',
      },
      [up('sm')]: {
        height: '13px',
      },
      [up('md')]: {
        height: '13px',
      },
      [up('lg')]: {
        height: '17px',
      },
      [up('xl')]: {
        height: '25px',
      },
      [up('xxl')]: {
        height: '34px',
      },
    },
  },
  [`& .${classes.addUserBtn}`]: {
    ':hover': {
      background: theme.palette.primary.main,
      color: 'white',
    },
    [up('xs')]: {
      width: '70px',
      height: '25px',
      marginTop: '29px',
    },
    [up('sm')]: {
      width: '74px',
      height: '24px',
      marginTop: '30px',
    },
    [up('md')]: {
      width: '92px',
      height: '26px',
      marginTop: '30px',
    },
    [up('lg')]: {
      width: '105px',
      height: '35px',
      marginTop: '35px',
    },
    [up('xl')]: {
      width: '115px',
      height: '40px',
      marginTop: '40px',
    },
    [up('xxl')]: {
      width: '133px',
      height: '52px',
      marginTop: '45px',
    },
  },
  [`& .${classes.formHelperText}`]: {
    marginLeft: theme.spacing(1.5),
    color: '#d32f2f',
  },
  [`& .${classes.loaderBox}`]: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100%',
  },
  [`& .${classes.newFlowBackdrop}`]: {
    color: theme.palette.secondaryWhite.main,
    zIndex: theme.zIndex.drawer + 1,
  },
  [`& .${classes.DeleteMemberCardHeader}`]: {
    width: '100%',
    color: theme.palette.darkPurple.main,
    background: theme.palette.japanBlush.main,
    [up('xs')]: {
      height: '40px',
    },
    [up('sm')]: {
      height: '60px',
    },
    [up('md')]: {
      height: '60px',
    },
    [up('lg')]: {
      height: '60px',
    },
    [up('xl')]: {
      height: '80px',
    },
    [up('xxl')]: {
      height: '90px',
    },
  },
  [`& .${classes.DeleteMemberCardContent}`]: {
    marginTop: '20px',
    width: '100%',
    [up('xs')]: {
      padding: '0px 6px',
    },
    [up('sm')]: {
      padding: '0px 9px',
    },
    [up('md')]: {
      padding: '0px 14px',
    },
    [up('lg')]: {
      padding: '0px 18px',
    },
    [up('xl')]: {
      padding: '0px 22px',
    },
    [up('xxl')]: {
      padding: '0px 30px',
    },
  },
  [`& .${classes.actionButtonBox}`]: {
    width: '100%',
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    [up('xs')]: {
      height: '35px',
      margin: '10px 0px',
    },
    [up('sm')]: {
      height: '50px',
      margin: '14px 0px',
    },
    [up('md')]: {
      height: '54px',
      margin: '16px 0px',
    },
    [up('lg')]: {
      height: '56px',
      margin: '20px 0px',
    },
    [up('xl')]: {
      height: '60px',
      margin: '20px 0px',
    },
    [up('xxl')]: {
      height: '60px',
      margin: '30px 0px',
    },
  },
  [`& .${classes.cancelButton}`]: {
    backgroundColor: theme.palette.paperWhite.main,
    color: theme.palette.lunarBase.main,
    marginTop: 0,
    [up('xs')]: {
      width: '80px',
      height: '30px',
      margin: '3px',
    },
    [up('sm')]: {
      width: '99px',
      height: '40px',
      margin: '4px',
    },
    [up('md')]: {
      width: '110px',
      height: '40px',
      margin: '6px',
    },
    [up('lg')]: {
      width: '110px',
      height: '44px',
      margin: '7px',
    },
    [up('xl')]: {
      width: '150px',
      height: '54px',
      margin: '10px',
    },
    [up('xxl')]: {
      width: '150px',
      height: '54px',
      margin: '10px',
    },
  },
  [`& .${classes.saveButton}`]: {
    marginTop: 0,
    [up('xs')]: {
      width: '80px',
      height: '30px',
      margin: '3px',
    },
    [up('sm')]: {
      width: '99px',
      height: '40px',
      margin: '4px',
    },
    [up('md')]: {
      width: '110px',
      height: '40px',
      margin: '6px',
    },
    [up('lg')]: {
      width: '110px',
      height: '44px',
      margin: '7px',
    },
    [up('xl')]: {
      width: '150px',
      height: '54px',
      margin: '10px',
    },
    [up('xxl')]: {
      width: '150px',
      height: '54px',
      margin: '10px',
    },
  },
  [`& .${classes.memberCards}`]: {
    maxHeight: '70vh',
    overflow: 'auto',
    '&::-webkit-scrollbar': {
      width: 0,
    },
  },
}));
